var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05051 4.05036C6.36333 2.73754 8.14389 2 10.0005 2C11.8571 2 13.6377 2.73754 14.9505 4.05036C16.2633 5.36318 17.0009 7.14375 17.0009 9.00036C17.0009 10.857 16.2633 12.6375 14.9505 13.9504L10.0005 18.9004L5.05051 13.9504C4.40042 13.3003 3.88474 12.5286 3.53291 11.6793C3.18108 10.83 3 9.91967 3 9.00036C3 8.08104 3.18108 7.17073 3.53291 6.32141C3.88474 5.47208 4.40042 4.70038 5.05051 4.05036ZM10.0005 11.0004C10.5309 11.0004 11.0396 10.7896 11.4147 10.4146C11.7898 10.0395 12.0005 9.53079 12.0005 9.00036C12.0005 8.46992 11.7898 7.96122 11.4147 7.58614C11.0396 7.21107 10.5309 7.00036 10.0005 7.00036C9.47007 7.00036 8.96136 7.21107 8.58629 7.58614C8.21122 7.96122 8.0005 8.46992 8.0005 9.00036C8.0005 9.53079 8.21122 10.0395 8.58629 10.4146C8.96136 10.7896 9.47007 11.0004 10.0005 11.0004Z",
    fill: "#1E1E1E",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.799682e6603e3236bf27893a139af912.svg";
export { ForwardRef as ReactComponent };